import React, { useState } from 'react';
import { API_URL } from '../api-config';
import { useNavigate } from 'react-router-dom';

const UserCreate = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
  
    const token = localStorage.getItem('token');
  
    try {
      const response = await fetch(`${API_URL}/users/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ email, username, password }),
      });
  
      if (response.ok) {
        setSuccess('¡Usuario creado exitosamente!');
        window.alert('¡Usuario creado exitosamente!');
        setEmail('');
        setUsername('');
        setPassword('');
      } else {
        const data = await response.json();
        let errorMessage = 'No se pudo crear el usuario';
  
        if (response.status === 422) {
          errorMessage = 'Datos de entrada inválidos. Por favor, verifica tu correo, nombre de usuario y contraseña.';
        } else if (response.status === 403) {
          errorMessage = 'No tienes permiso para realizar esta acción.';
        } else {
          errorMessage = typeof data.detail === 'object' ? JSON.stringify(data.detail) : data.detail || errorMessage;
        }
  
        setError(errorMessage);
      }
    } catch (err) {
      setError('Ocurrió un error');
    }
  };
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-900">
      <div className="w-full max-w-md p-8 space-y-6 bg-slate-800 rounded-lg shadow-lg">
        {/* Título */}
        <h2 className="text-3xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-200">
          Crear Usuario
        </h2>

        <button
        onClick={() => navigate('/users')}
        className="fixed bottom-6 right-6 z-20 bg-purple-600 text-white px-4 py-2 rounded-full hover:bg-purple-700 transition-all duration-300 shadow-lg"
      >
        Volver
      </button>

        {/* Mensajes de error o éxito */}
        {error && (
          <div className="p-2 text-sm text-red-300 bg-red-900/20 rounded">
            {error}
          </div>
        )}
        {success && (
          <div className="p-2 text-sm text-green-300 bg-green-900/20 rounded">
            {success}
          </div>
        )}

        {/* Formulario */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Campo de Email */}
          <div>
            <label className="block text-sm font-medium text-white">Email</label>
            <div className="relative mt-1">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 text-white bg-slate-700 border border-purple-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:bg-slate-600"
                placeholder="ejemplo@correo.com"
                required
              />
            </div>
          </div>

          {/* Campo de Nombre de Usuario */}
          <div>
            <label className="block text-sm font-medium text-white">
              Nombre de Usuario
            </label>
            <div className="relative mt-1">
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-2 text-white bg-slate-700 border border-purple-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:bg-slate-600"
                placeholder="Usuario123"
                required
              />
            </div>
          </div>

          {/* Campo de Contraseña */}
          <div>
            <label className="block text-sm font-medium text-white">
              Contraseña
            </label>
            <div className="relative mt-1">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 text-white bg-slate-700 border border-purple-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:bg-slate-600"
                placeholder="********"
                required
              />
            </div>
          </div>

          {/* Botón de Envío */}
          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-purple-600 rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
          >
            Crear Usuario
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserCreate;
